/* eslint-disable max-len */
import { useIntl } from 'react-intl';
import { useEffect, useState } from 'react';
import QualificationLogos from 'src/Components/Qualifications/QualificationLogos';
import ProductCard from 'src/Components/Product/ProductCard';
import { TertiaryButton } from '@luminalearning/components';
import { useNavigate } from 'react-router-dom';
import { activePractitionerDetails } from 'src/graphql';
import { useReactiveVar } from '@apollo/client';
import MainLayout from './MainLayout';

const Products = () => {
    const navigate = useNavigate();
    const [productQualifications, setProductQualifications] = useState<any>(null);
    const practitionerData = useReactiveVar(activePractitionerDetails);
    const intl = useIntl();
    useEffect(() => {
        document.title = intl.formatMessage({ id: 'LP_LUMINA_PRODUCTS', defaultMessage: 'Lumina Products' });
        if (practitionerData) {
            setProductQualifications(practitionerData.productQualifications);
        }
    }, [practitionerData, intl]);

    return (
        <MainLayout>
            <div className='w-screen mr-0 pl-8 md:pl-1 lg:ml-0 pr-8 md:my-10'>
                <div className='justify-center mb-6'>
                    <TertiaryButton onClick={() => { navigate('/'); }} text={intl.formatMessage({
                        id: 'LP_BACK_TO_HOME',
                        defaultMessage: 'Back to Practitioner Dashboard',
                    })} direction='Left' />
                    <h1 className='text-headline-lg font-black mt-6' style={{ lineHeight: '45px' }}>
                        {
                            intl.formatMessage({
                                id: 'LP_AVAILABLE_PRODUCTS',
                                defaultMessage: 'Your Products',
                            })
                        }
                    </h1>
                    <p className='mt-6 ml-2'>
                        {
                            intl.formatMessage({
                                id: 'LP_PRODUCT_EXPLANATION',
                                defaultMessage: 'See all the products you have access to',
                            })
                        }
                    </p>
                </div>
                {productQualifications
                    && <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 pr-4'>
                        {productQualifications.map((qualification: any, index: number) => {
                            const { qualificationName, products, colorTheme } = qualification;
                            return (
                                <ProductCard
                                    productQualificationName={qualificationName}
                                    productLogo={
                                        <img src={QualificationLogos[qualificationName] == null ? '/img/lumina-logo.png' : QualificationLogos[qualificationName]}
                                            alt={QualificationLogos[qualificationName]} />}
                                    products={products}
                                    productColorTheme={colorTheme}
                                    key={index}
                                />
                            );
                        })}
                    </div>
                }
            </div>
        </MainLayout>
    );
};

export default Products;